import React from "react";
import { getCompanyDetailInfo } from "@/redux/organization/selector";
import { useDispatch, useSelector } from "react-redux";
import {
	AppDetailContents,
	AppDetailTitle,
	AppDetailWrapper,
	AppListWrapper,
	AppPaymentChangeButton,
	AppTitleName,
	AppTitleNameWrapper,
	AppTitleWrapper,
	DescriptionUpperTitleImage,
} from "./style";
import application_icon from "@/assets/application_icon.svg";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import { ko } from "date-fns/locale";
import { useTranslation } from "react-i18next";

export default function ApplicationList() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const history = useHistory();
	const companyDetailInfo = useSelector(getCompanyDetailInfo)?.body;
	console.log(companyDetailInfo);
	return (
		<>
			<div style={{ paddingTop: "24px" }}>
				{companyDetailInfo?.apps.map((app, index) => {
					return (
						<AppListWrapper>
							<AppTitleWrapper>
								<AppTitleNameWrapper>
									<DescriptionUpperTitleImage>
										<img
											src={application_icon}
											alt="사진없음"
											style={{ width: "90%" }}
										/>
									</DescriptionUpperTitleImage>
									<AppTitleName>{app.name}</AppTitleName>
								</AppTitleNameWrapper>
								<AppPaymentChangeButton
									variant="outlined"
									onClick={() =>
										history.push(`/price`, {
											appId: app.id,
											appName: app.name,
											isUse: app.isUse,
										})
									}
								>
									{t("organization_general.change_payment")}
								</AppPaymentChangeButton>
							</AppTitleWrapper>
							<AppDetailWrapper>
								<AppDetailContents>
									<AppDetailTitle width="8rem">
										{t("organization_general.subscription_plan")}
									</AppDetailTitle>
									<div style={{ fontWeight: 700 }}>{app.planName}</div>
								</AppDetailContents>
								<AppDetailContents>
									<AppDetailTitle width="10rem">
										{t("organization_general.used_api")}
									</AppDetailTitle>
									<div style={{ fontWeight: 700 }}>
										{app.isFoodLens ? "FoodLens" : "CaloAI"}
									</div>
								</AppDetailContents>
								<AppDetailContents>
									<AppDetailTitle width="8rem">
										{t("organization_general.creation_date")}
									</AppDetailTitle>
									<div>
										{format(
											new Date(app.createdAt),
											"yyyy년 MM월 dd일",
											{ locale: ko },
										)}
									</div>
								</AppDetailContents>
								<AppDetailContents>
									<AppDetailTitle width="10rem">
										{t("organization_general.android_package_name")}
									</AppDetailTitle>
									<div>
										{app.packageAndroid === ""
											? "-"
											: app.packageAndroid}
									</div>
								</AppDetailContents>
								<AppDetailContents>
									<AppDetailTitle width="8rem">
										{t("organization_general.renewal_date")}
									</AppDetailTitle>
									<div>
										{format(
											new Date(app.nextPaymentAt),
											"yyyy년 MM월 dd일",
											{
												locale: ko,
											},
										)}
									</div>
								</AppDetailContents>
								<AppDetailContents>
									<AppDetailTitle width="10rem">
										{t("organization_general.ios_package_name")}
									</AppDetailTitle>
									<div>
										{app.packageIos === "" ? "-" : app.packageIos}
									</div>
								</AppDetailContents>
							</AppDetailWrapper>
						</AppListWrapper>
					);
				})}
			</div>
		</>
	);
}
